import { ICD9Procedure, ICD9ProcedureQuery } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { BindingCreator } from '@dreryk/react-common';
import { Autosuggest } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

import { patientMedicalInformationTranslationKeys } from '../../../translations';

const t = patientMedicalInformationTranslationKeys.medicalImaging.form;

const procedureLabelExtractor = ({ code, name }: ICD9Procedure): string => `${code} ${name}`;
const procedureItemRenderer = ({ code, name }: ICD9Procedure): JSX.Element => {
   return (
      <>
         <strong>{name}</strong> {` (${code})`}
      </>
   );
};

const proceduresSearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<ICD9Procedure[]> =>
      performCqrsQuerySearch<ICD9Procedure>(() => {
         const query = new ICD9ProcedureQuery();
         if (searchText) {
            query.codeOrName = TextPattern.anywhereIgnoreCase(searchText);
            query.dictionaryValidOn = new Date(Date.now());
         }
         return query;
      });
};

const PROCEDURE_SELECTOR_FIELD_NAME = 'icd9Procedure';

type ProcedureSelectorType = ICD9Procedure;

export type ProcedureSelectorFormBeanPart = { [PROCEDURE_SELECTOR_FIELD_NAME]: ProcedureSelectorType };

type ProcedureSelectorProps = { readonly register: BindingCreator<ProcedureSelectorFormBeanPart> };

export const ProcedureSelector = (props: ProcedureSelectorProps): JSX.Element => {
   return (
      <Autosuggest<ICD9Procedure>
         label={t.procedureSelector.label}
         placeholder={t.procedureSelector.placeholder}
         controller={props.register(PROCEDURE_SELECTOR_FIELD_NAME, { required: true })}
         labelExtractor={procedureLabelExtractor}
         itemRenderer={procedureItemRenderer}
         searchCreator={proceduresSearchCreator}
         keyProperty={'code'}
         minChars={2}
         testId={'procedureSelector'}
      />
   );
};
